module.exports = __webpack_public_path__ + "static/media/satellite.bcf76661.svg";